module.exports = __webpack_public_path__ + "img/ZRAgent.467f1199.png";